// extracted by mini-css-extract-plugin
module.exports = {"container":"snackbar-manager-module__container___kzfrm","snackbar-slide-in":"snackbar-manager-module__snackbar-slide-in___5t6T-","clear":"snackbar-manager-module__clear___+S0-A"};